import React from "react";
import Marquee from "react-fast-marquee";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const marqueeDataWithLinks = [
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765736103/et_logo_1_k5pi3x.svg",
    website: "https://easterntechno.com/",
  },

  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538473/image_8_lrosv8.svg",
    website: "https://limspakistan.org/home",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538473/image_10_ejd7xp.svg",
    website: "https://rcci.org.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538473/image_3_svmryq.svg",
    website: "https://www.cda.gov.pk/",
  },
  {
    link: "hhttps://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538471/image_9_cvtxj6.svg",
    website: "https://mis.nha.gov.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538463/image_5_vckkme.svg",
    website: "https://www.nlc.com.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538474/image_15_xchqm0.svg",
    website: "https://rawalpindi.cantonment.gov.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538462/image_2_bngaro.svg",
    website: "https://wasarwp.gop.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538462/image_4_mvvuze.svg",
    website: "https://fwopk.com/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538472/image_13_z6kgop.svg",
    website: "https://www.rwmc.org.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538461/image_6_nojewa.svg",
    website: "https://nespak.com.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538482/image_14_d676cd.svg",
    website: "http://pmaislamabad.org.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765608435/image_12_z11jkx.svg",
    website: "https://www.ccb.gov.pk",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538464/image_1_d6umb2.svg",
    website: "http://pharwp.punjab.gov.pk/",
  },
  {
    link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765538463/image_7_blkmfg.svg",
    website: "https://mmpakistan.com/",
  },
];
const PartnerMarquee = () => {
  return (
    <div className="flex flex-col items-center gap-10 pb-10 xl:pt-20  lg:pt-14 md:10 py-6 ">
      <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[1.8rem] font-bold text-center">
        Partners in progress
      </span>
      <Marquee
        direction="left"
        gradient={false}
        pauseOnHover={true}
        speed={100}
        className=" flex items-center gap-10"
      >
        <div className=" flex items-center gap-10">
          {marqueeDataWithLinks?.map((icon, i) => (
            <NavLink to={icon?.website} target="_blank">
              <ReactSVG
                key={i}
                src={icon?.link}
                beforeInjection={(svg) => {
                  svg.setAttribute("height", "80"); // = h-20
                  svg.setAttribute("width", "auto");
                  svg.style.height = "80px";
                  svg.style.width = "auto";
                }}
                className="h-20 w-auto"
              />
            </NavLink>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default PartnerMarquee;
